import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#004240',
    secondary: '#FFFFFF',
    accent: '#01C993',
    button: '#15252B',
    error: '#CE4760',
    info: '#36C997',
    success: '#0AC294',
    warning: '#FFC933',
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

switch (window.env.VUE_APP_AMBIENTE) {
  case 'pagol':
    themes = {
      light: {
        primary: '#001833',
        secondary: '#F4F4F5',
        accent: '#FA4300',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'digicash':
    themes = {
      light: {
        primary: '#004240',
        secondary: '#004240',
        accent: '#01C993',
        button: '#15252B',
        error: '#CE4760',
        info: '#36C997',
        success: '#0AC294',
        warning: '#FFC933',
      }
    }
    break
  case 'fgtsbmp':
    themes = {
      light: {
        primary: '#1f337d',
        secondary: '#F4F4F5',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'lucash_fgts':
    themes = {
      light: {
        primary: '#2c3753',
        secondary: '#F4F4F4',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'volus':
    themes = {
      light: {
        primary: '#404545',
        secondary: '#76C96E',
        accent: '#FA4300',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'girocred_fgts':
    themes = {
      light: {
        primary: '#14103D',
        secondary: '#14103D',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'v12_fgts':
    themes = {
      light: {
        primary: '#006E8D',
        secondary: '#A3A3A3',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'souzacred':
    themes = {
      light: {
        primary: '#14103D',
        secondary: '#1A52D9',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'master3fgts':
    themes = {
      light: {
        primary: '#176f31',
        secondary: '#176f31',
        accent: '#94ff29',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'viainvest_fgts':
    themes = {
      light: {
        primary: '#2B2E65',
        secondary: '#ED7623',
        accent: colors.blue.accent1,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'bmdcfgts':
    themes = {
      light: {
        primary: '#EADE02',
        secondary: '#306C38',
        accent: colors.blue.accent1,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'segue':
    themes = {
      light: {
        primary: '#002733',
        secondary: '#8EE000',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
}

let background = '/assets/imgs/background.svg'
let logo = '/assets/imgs/logo.svg'

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/background.svg')
    background = '/assets/imgs/' + localStorage.ambiente + '/background.svg'
  }
} catch { }
try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/logo.svg')
    logo = '/assets/imgs/' + localStorage.ambiente + '/logo.svg'

    var favicon = document.getElementById('custom-favicon')
    favicon.setAttribute('href', '/assets/imgs/' + localStorage.ambiente + '/favicon.svg')
  }
} catch { }

var headerColor = themes.light.primary
var logoHeaderHome = 'assets/imgs/' + localStorage.ambiente + '/logo.svg'
var backgroundHome = null
var button = {
  color: '#F4F4F5',
  class: 'primary--text'
}
var headerTextDark = false

switch (window.env.VUE_APP_AMBIENTE) {
  case 'pagol':
    button = {
      color: themes.light.primary,
      class: 'white--text'
    }
    headerTextDark = true
    break;
  case 'digicash':
    headerColor = '#F4F4F5'
    break;
  case 'lucash_fgts':
    logoHeaderHome = 'assets/imgs/lucash_fgts/logo-inverted.svg'
    headerTextDark = true
    break;
  case 'girocred_fgts':
    button = {
      color: '#F4F4F4',
      class: themes.light.primary
    }
    headerColor = '#F4F4F4'
    break;
  case 'v12_fgts':
    headerColor = '#F4F4F4'
    break;
  case 'souzacred':
    backgroundHome = 'assets/imgs/souzacred/background-home.svg'
    headerTextDark = true
    break;
  case 'master3fgts':
    backgroundHome = 'assets/imgs/master3fgts/background-home.svg'
    button = {
      color: '#F4F4F4',
      class: themes.light.primary
    }
    headerColor = '#F4F4F4'
    break;
  case 'viainvest_fgts':
    backgroundHome = 'assets/imgs/viainvest_fgts/background-home.svg'
    button = {
      color: '#F4F4F4',
      class: themes.light.primary
    }
    headerTextDark = true
    break;
  case 'segue':
    headerTextDark = true
    backgroundHome = 'assets/imgs/segue/background-home.svg'
    logo = '/assets/imgs/segue/logo-inverted.svg'
    break;
  case 'bmdcfgts':
    break;
}

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false,
    toolbar: { color: headerColor, dark: headerTextDark },
    home: {
      button: button
    },
    logoHeaderHome,
    backgroundHome
  },
  background,
  logo,
  themes: themes
}
